import { render } from "./VerifyEmail.vue?vue&type=template&id=7b6cbe37"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__